<template>
    <div class="admin admin-buy">
      <p class="admin-title a-flex-start a-align-items-center">
        {{$t('form.lot.lot-creation')}}
        <router-link :to="{name: 'purchases-my-lots-details', params: { lotId: lot.id, tab: 'overview'}}"
                     class="gui-btn gui-btn--red gui-btn--w-300 u-margin-left-20"
                     v-if="lot.hasPublic">
          На публичную страницу закупки
        </router-link>
      </p>

      <div class="a-tab" id="accordion-tab">
        <div class="a-tab__control">
          <router-link to="overview" tag="button" type="button" class="a-tab__btn" active-class="a-active " >{{$t('form.lot.basic-data')}}</router-link>
          <router-link to="specifications" tag="button" type="button" class="a-tab__btn" active-class="a-active">{{$t('form.lot.specification')}}</router-link>
<!--          <router-link to="request-template" tag="button" type="button" class="a-tab__btn" active-class="a-active"></router-link>-->
        </div>
        <div class="collapse" :class="showOverview && 'show'">
          <form class="human-data" action="">
            <purchase-overview :lot="lot"></purchase-overview>
          </form>
        </div>
        <div class="collapse" :class="showSpecifications && 'show'">
          <form class="human-data" @submit.prevent>
              <purchase-specification :lot="lot" :isVisible="showSpecifications"></purchase-specification>
          </form>
        </div>
      </div>
    </div>
</template>

<script>
  import PurchaseOverview from './Overview'
  import PurchaseSpecification from './Specification'
  import CommonMixins from './mixins/common'

  export default {
    props: {
      lot: Object
    },

    components: {
      PurchaseOverview,
      PurchaseSpecification
    },

    mixins: [
      CommonMixins
    ],

    watch: {
      lot: {
        deep: true,
        handler: async function(value, old) {
          console.info('Details: detected lot object is changed lot=', value, ', old=', old);
        }
      }
    },

    computed: {
      showOverview() {
        return this.$route.params.tab === 'overview'
      },

      showSpecifications() {
        return this.$route.params.tab === 'specifications'
      }
    }
  }
</script>

<style>
  .a-tab__btn {
    color: #4C4C4C;
    border-bottom: 1px solid transparent;
  }

  .a-tab__btn.a-active {
    color: #E30613;
    border-bottom: 1px solid #E30613;
  }
</style>
